/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Clinic } from './Clinic';
import type { SimplePatientInsurance } from './SimplePatientInsurance';

export type Patient = {
    readonly id?: number;
    first_name: string;
    last_name?: string | null;
    date_of_birth?: string | null;
    readonly clinic?: Clinic;
    /**
     * HL7 single character representation of sex: F, M, O, U, A
     */
    sex?: Patient.sex | null;
    insurance: Array<SimplePatientInsurance>;
    /**
     * populated by WPL PID.4 unique patient account number
     */
    has_history?: boolean;
    phone?: string | null;
    mobile_phone?: string | null;
    /**
     * MRN / medical record number for the patient from the source system
     */
    medical_record_number?: string | null;
    external_patient_id?: string | null;
}

export namespace Patient {

    /**
     * HL7 single character representation of sex: F, M, O, U, A
     */
    export enum sex {
        M = 'M',
        F = 'F',
        O = 'O',
        U = 'U',
        A = 'A',
    }


}
